import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "db-not-available-page",
  imports: [CommonModule],
  template: `
    <div class="flex justify-center items-center min-h-screen p-5 bg-[#f5f5f5]">
      <div class="text-center max-w-[500px] p-10 bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.08)]">
        <img src="/assets/images/deskbird-logo.svg" alt="deskbird" class="w-[120px] mb-6" />
        <h1 class="text-[#1a1a1a] text-2xl mb-4">Page Not Available</h1>
        <p class="text-[#666] text-base leading-normal mb-4">
          The information you're looking for is not available. This could be because:
        </p>
        <ul class="text-left text-[#666] text-sm leading-[1.8] pl-5 mb-4">
          <li>The link has expired</li>
          <li>The link is invalid</li>
        </ul>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAvailablePageComponent {}
